import {
  getIndex,
  getAllIndexKeys,
  getMainStoreInstance,
  getMainHelper,
  mainStoreName,
  widgets,
} from '../../common/Algolia';
import {
  stripHTML,
} from '../../common/Utils';
import {
  triggerAlgoliaProductListSortByEvent,
} from '../../common/Events';
import {
  getItemBrand,
  getItemCategory,
  getItemVariant,
  getItemClass,
  getItemListName,
} from '../../common/organism/product-thumbnails-module';

// Constants (ids)
const sortById = 'ais-sort-by';

// Constants (classes)
const selectClass = 'ais-sort-by-selector';
const sliderHandle = 'ais-range-slider--handle';
const sliderTooltip = '.ais-range-slider--tooltip';
// const itemListClass = 'o-product-thumbnails-module__item--list';

// Constants (attributes)
const dataSkuAttr = 'data-ocms-thumb-sku';

/* Store instance */
let occStore;
let helper;

/* DOM elements use as starting points */
let $sortBy;
let dicoOrderKeys;

/* Will be used after template rendering (render event) */
let $select;
let rawProducts;

/* Register events after the rendering */
function sortByEventSetup() {
  if (typeof occStore !== 'undefined') {
    occStore.once('render', () => {
      helper = getMainHelper();
      $select = $(`.${selectClass}`);
      let searchKeyword = '';
      let getState;
      let disjunctiveFacetsRefinements;
      let disjunctiveFacetsRefinementsArray = [];
      let filterTypeValueArray = [];
      let filterTypeValueString = '';
      let productsList = [];

      let $elem;
      let price = '';
      let priceMin = '';
      let priceMax = '';

      let selectedValue;
      let sortByListArray;
      let matchingKeyObj;
      let sortTypeValue;

      // Trigger ProductListSortByEvent at the result after the user clicked on an item in the "sort by" dropdown list.
      helper.on('result', (results) => {
        if (sortTypeValue !== undefined) {
          // Get the query
          searchKeyword = results.query;

          // Get the raw products data
          rawProducts = results.hits;

          // empty those array to avoid mismatched data at each sortBy
          disjunctiveFacetsRefinementsArray = [];
          filterTypeValueArray = [];
          productsList = [];

          // Save products datas in productsList
          for (let i = 0, len = rawProducts.length; i < len; i += 1) {
            $elem = $(`li[${dataSkuAttr}="${rawProducts[i].sku}"]`);

            productsList.push({
              id: rawProducts[i].id,
              brand: getItemBrand($elem),
              price: rawProducts[i].price_f,
              name: rawProducts[i].title,
              variant: getItemVariant($elem),
              category: getItemCategory($elem),
              position: i + 1,
              productClass: getItemClass($elem),
              list: getItemListName($elem),
            });
          }

          // Strip all HTML in one hit
          productsList = JSON.parse(stripHTML(JSON.stringify(productsList)));

          // Retrieve the selected filters
          getState = helper.getState();
          disjunctiveFacetsRefinements = getState.disjunctiveFacetsRefinements;

          // Save each retrieved filters in disjunctiveFacetsRefinementsArray
          $.each(disjunctiveFacetsRefinements, (key, val) => {
            disjunctiveFacetsRefinementsArray.push({ types: key, values: val });
          });

          // Format and save type/values in filterTypeValueArray
          for (let j = 0, jLen = disjunctiveFacetsRefinementsArray.length; j < jLen; j += 1) {
            const tempValues = disjunctiveFacetsRefinementsArray[j].values;

            for (let k = 0, kLen = tempValues.length; k < kLen; k += 1) {
              filterTypeValueArray.push(`${disjunctiveFacetsRefinementsArray[j].types}:${tempValues[k]}`);
            }
          }

          // Retrieve Min and Max price
          priceMin = $(`.${sliderHandle}-lower`).find(sliderTooltip).text();
          priceMax = $(`.${sliderHandle}-upper`).find(sliderTooltip).text();

          // Add price range to filterTypeValueArray
          price = `price:${priceMin}-${priceMax}`;
          filterTypeValueArray.push(price);

          // Convert filterTypeValueArray to a string with pipe separation
          filterTypeValueString = filterTypeValueArray.join(' | ');

          // Trigger event and pass data
          triggerAlgoliaProductListSortByEvent(
            productsList,
            {
              sortType: sortTypeValue,
              filters: filterTypeValueString,
              siteSearchKeyword: searchKeyword
            }
          );
        }
      });

      // Retrieve the sortBy type value When the user clicks on an item in the "sort by" dropdown list.
      $select.on('change', () => {
        selectedValue = $sortBy.find('select').val();
        sortByListArray = window.algolia.sortByList;
        matchingKeyObj = $(sortByListArray).filter(i =>
          sortByListArray[i].index === selectedValue
        );
        sortTypeValue = matchingKeyObj[0].key;
      });
    });
  }
}

/* Searchbox wideget setup */
function sortByInit() {
  /* Init elements */
  $sortBy = $(`#${sortById}`);

  if ($sortBy.length > 0) {
    const indexConfig = [];

    /* Get Store instance */
    occStore = getMainStoreInstance();
    dicoOrderKeys = getAllIndexKeys(mainStoreName);

    try {
      /* Loop through index and associate dicokeys for labels */
      for (let i = 0, len = dicoOrderKeys.length; i < len; i += 1) {
        const tempKey = dicoOrderKeys[i];
        const tempIndex = getIndex(mainStoreName, tempKey);

        indexConfig.push({ name: tempIndex.index, label: tempIndex.name });
      }
    } catch (error) {
      console.error('===== Missing dicoKeys for AIS-SORT-BY =====', error);
    }

    occStore.addWidget(
      widgets.sortBySelector({
        container: $sortBy[0], // Expect a vanilla DOM object
        indices: indexConfig,
        cssClasses: {
          root: 'm-sort-internal-search__container',
          select: 'm-sort-internal-search__select a-select',
        },
      })
    );

    sortByEventSetup();

    return true;
  }

  return false;
}

// Named exports
export default sortByInit;



// WEBPACK FOOTER //
// ./js/desktop/molecule/algolia-sort-by.js